import { Suspense, lazy } from 'react';
import { Spin } from 'antd';
import componentLoader from './componentLoader';

const loadable = (importFunc, { fallback } = { fallback: <Spin /> }) => {
  const LazyComponent = lazy(() => componentLoader(() => importFunc), 10);

  return (props) => (
    <Suspense fallback={fallback}>
      <LazyComponent {...props} />
    </Suspense>
  );
};

export default loadable;
